import { queryOptions, useQuery } from '@tanstack/react-query'

import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

import { notificationApi } from '../api/notificationApi'
import type { TGetNotificationSettingsPayload } from '../api/types/getNotificationSettings'

export const getNotificationSettingsQueryOptions = (
  payload: TGetNotificationSettingsPayload = { isSubscriptionAlive: true },
  hasUpdateParametersToken: boolean = false,
) => {
  return queryOptions({
    queryKey: ['me_notification_settings', payload],
    queryFn: ({ signal }) => notificationApi.getNotificationSettings(payload || {}, { signal }),
    retry: 0,
    enabled: getIsLoggedIn() || hasUpdateParametersToken,
  })
}

export const useNotificationSettingsQuery = (
  payload?: TGetNotificationSettingsPayload,
  hasUpdateParametersToken?: boolean,
) => useQuery(getNotificationSettingsQueryOptions(payload, hasUpdateParametersToken))
